// extracted by mini-css-extract-plugin
module.exports = {"alert":"AlertNotification_alert__1VyaO","icon":"AlertNotification_icon__3O_tf","okButton":"AlertNotification_okButton__auhtN"};